import Change3DSAnswer from './Change3DSAnswer';

export default Change3DSAnswer;